import React, { useContext, useEffect } from 'react';
import { Platform, Image } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { Text, BlurView, View, Title, ScrollView } from '@constants/Themed';
import apis from '@api/api';
import { DefaultRootState } from '@reduxLocal/persistState';
import AchievementList from '@components/cards/achievementList';
import AchievementTable from './AchievementTable';
import { useQuery } from '@tanstack/react-query';
import DefaultScreen from '@components/Global/DefaultScreenView';
import DropDownView from '@components/Global/DropDownView';
import AnimatedLottieView from '@utils/lottieAnimation';
import { useLottieAnim } from '@hooks/lottieHook';
import { CountUp } from 'use-count-up';
import styles from '@stylesheet';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import GetAvatarImage from '@hooks/getAvatarImage';
import toTitleCase from '@hooks/toTitleCase';
import { selectUser } from '@reduxLocal/selectors/userSelectors';

const AchievementsScreen = () => {
  const points = useSelector((state: DefaultRootState) => state.promiseData.data.userData.achievements.achievementPoints)
  const animation = useLottieAnim();
  const theme = themeSelector();
  const user = selectUser();
  const dispatch = useDispatch();

  const { status, data, error, isFetching, isLoading } = useQuery({
    queryKey: ['data'],
    queryFn: async () => {
      const data = await apis.refreshAchievements(user.id)
        .then(res => {
          return res
        });
      return data
    },
  });


  return (
    <DefaultScreen screenTitle={'Achievements'} noMargin scrollDisabled style={{ flex: 1 }}>
      <View style={{ flex: 1, flexDirection: 'column', alignSelf: 'stretch' }} >
        <View style={{ flex: 1, maxHeight: 350, paddingVertical: 20 }}>
          {/* <BlurView style={styles.blurViewStyle} blurType={theme ? 'light' : "dark"} blurAmount={10} reducedTransparencyFallbackColor="white" pointerEvents='none' /> */}
          <View style={{ flex: 1, borderRadius: 20, minHeight: 400, padding: 20, paddingTop: -4 }}>
            <View style={{ flexDirection: 'row', flex: 1, padding: 20, gap: 20 }}>
              <View style={{ flex: 1, borderTopLeftRadius: 20, borderBottomLeftRadius: 20, padding: 20, left: -35 }} >
                <GetAvatarImage />
              </View>
              <View style={{ flex: 3, borderTopRightRadius: 20, borderBottomRightRadius: 20, paddingVertical: 30, gap: 10 }} >
                <Text style={{ fontSize: 22, fontWeight: 'bold', textAlign: 'center', overflow: 'visible' }}>{toTitleCase(user.name)} {toTitleCase(user.surname)}</Text>
                <Text style={{ fontSize: 18, fontWeight: '600', textAlign: 'center', overflow: 'visible' }}>{user.email}</Text>
              </View>
            </View>
            <View style={{ flex: 1, flexDirection: 'row', paddingVertical: 10 }}>
              <Text style={{ fontSize: 28, flex: 3, color: 'white', alignSelf: 'center', paddingVertical: 10, justifyContent: "center" }}>
                <CountUp isCounting={true} start={0} end={user.achievements?.achievement_points} />
                <Text adjustsFontSizeToFit style={{ fontSize: 12 }}>pts</Text>
              </Text>
            </View>
          </View>
        </View>
        <ScrollView style={{ flex: 5 }} contentContainerStyle={{ paddingBottom: 100, padding: 10 }}>
          {
            isLoading ?
              <AnimatedLottieView source={require("@assets/animations/leaf_Loader.json")} autoPlay style={{width: 50, height: 50}} loop />
              :
              <View style={{ flex: 1 }}>
                {
                  !error ?
                    <AchievementTable achievementList={data} />
                    :
                    <AnimatedLottieView source={require("@assets/animations/leaf_Loader.json")} autoPlay style={{width: 50, height: 50}} loop />
                }
              </View>
          }
        </ScrollView>
      </View >
    </DefaultScreen>
  );
}

export default AchievementsScreen;